module.exports = __webpack_public_path__ + "img/bostonma.75dc3a6d.jpg";